import { getClientIPFromHeaders } from "@repo/http"
import { getSiteUrl } from "@repo/shared"
import { redirect } from "next/navigation"
import React from "react"

import { ScrollHandler } from "./_components"
import { HeaderContentWithScroll } from "./_components/HeaderContentWithScroll"
import { filterAnnouncements } from "./helpers/announcementUtils"
import { getTokenFromCookies } from "./helpers/cookieUtils"
import { HeaderProps } from "./interface"
import { getAnnouncementsServer } from "./servers/newscenter"
import { getMarkets } from "./servers/spotoverseascenter/getMarkets"
import { getUserInfoServer } from "./servers/usercenter/getUserInfoServer"
import { getCurrentUrl } from "./utils"

/**
 * Header 内容组件（服务端）
 * @description 负责数据获取和业务逻辑处理
 */
const HeaderContent: React.FC<HeaderProps> = async (props) => {
  // 优先获取 token，因为 userInfo 依赖它
  const token = await getTokenFromCookies()
  // 获取 headers 信息用于 clientIP
  const { headers } = await import("next/headers")
  const headersList = await headers()
  const clientIP = getClientIPFromHeaders(headersList)

  // 并行获取数据，token 失效时返回 null（通过 catch 捕获错误，不中断渲染）
  const [markets, userInfo, announcementsResponse] = await Promise.all([
    getMarkets(clientIP),
    token ? getUserInfoServer().catch(() => null) : Promise.resolve(null),
    getAnnouncementsServer(),
  ])

  if (token && !userInfo) {
    // 获取请求头地址
    const originalUrl = headersList.get("X-Original-URL") || headersList.get("x-original-url")
    // originalUrl为true 代表是测试环境或者生产环境, 开发环境使用getCurrentUrl获取当前url
    const currentUrl = originalUrl || getCurrentUrl(headersList)
    redirect(`${getSiteUrl("user")}/login?url=${encodeURIComponent(currentUrl)}&clearAuth=true`)
  }

  // 处理市场数据（移除第一项）
  const processedMarkets = markets?.slice(1) || []
  const announcements = announcementsResponse?.list || []
  const filteredAnnouncements = await filterAnnouncements(announcements)

  return (
    <ScrollHandler>
      <HeaderContentWithScroll
        {...props}
        markets={processedMarkets}
        userInfo={userInfo}
        announcements={filteredAnnouncements}
      />
    </ScrollHandler>
  )
}

const Header = async (props: HeaderProps) => {
  return <HeaderContent {...props} />
}

export default Header
